@let marketingOrder = marketingOrder$ | async;

<re-spinner [showOverlay]="true" [spinner]="spinner" />

<h4>Add multimedia links about your listing</h4>

@if (!AppService.isDCApp) {

  <div class="fx-row fx-gap-sm mb-lg">
    <mat-icon>tips_and_updates</mat-icon>
    <div>
      <strong>{{ brandService.applicationName() }} Pro Tips:</strong>
      <p class="m-0">Video links used for YouTube advertising must meet the following criteria:</p>
      <ul class="m-0 pl-4">
        @for (tip of videoLinkTips(); track $index) {
        <li>{{ tip }}</li>
        }
      </ul>
      <p class="mt-3 m-0">Video links used for property websites, must meet the following criteria:</p>
      <ul class="m-0 pl-4">
        @for (tip of videoLinkPropertyWebsiteTips(); track $index) {
        <li>{{ tip }}</li>
        }
      </ul>
    </div>
  </div>
}

<lc-multi-media-item-form class="pt-md" idPrefix="add" [formGroup]="addFormGroup" />

<div class="fx-row x-end">
  <button color="primary"
          id="multimediaitem-add-link"
          lcTestId="multimediaitem-add-link"
          mat-raised-button
          type="button"
          [disabled]="!addFormGroup.valid"
          (click)="addLink()"
  >
    Add Link
  </button>
</div>

<lc-multimedia-table [items]="marketingOrder.media?.multimedia ?? []"
                     (onDelete)="deleteSelected($event)"
                     (onUpdate)="updateItem($event)"
/>
